import ColorThemeAwareDiagram from './color-theme-aware-diagram.js'

const tpl = document.createElement('template');

tpl.innerHTML = `
  <div class="observations-container">
    <slot></slot>

    <div class="visualization">
      <div class="donut-inner">
        <h5 class="quantity-sum"></h5>
        <small>Individuen</small>
      </div>

      <canvas></canvas>
    </div>
  </div>

  <style>
    slot {
      grid-area: table;
    }
    .observations-container {
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      align-items: center;
      justify-items: center;
      justify-content: center;
    }
    .visualization {
      display: grid;
      grid-template-areas: "canvas";
      align-items: center;
      justify-items: center;
      margin-bottom: 1rem;
    }
    canvas {
      grid-area: canvas;
    }
    .donut-inner {
      grid-area: canvas;
      display: block;
      text-align: center;
    }
    .quantity-sum {
      font-size: 1.6rem;
      margin: 0 auto;
    }
  </style>
`;

export default class ObservationsDiagram extends ColorThemeAwareDiagram {

  chartData = {
    labels: [],
    datasets: [{
      data: [],
      borderColor: _ => this.borderColor,
      backgroundColor: [],
      hoverBorderColor: [],
      hoverBackgroundColor: []
    }]
  }

  constructor() {
    super();

    this.chartOptions = {
      cutout: '60%',
      animation: {
        animateRotate: false
      },
      plugins: {
        legend: {
          display: false
        }
      }
    }

    this.datasetSelector  = this.dataset.datasetSelector  || 'table .dataset';
    this.speciesSelector  = this.dataset.speciesSelector  || '.species';
    this.quantitySelector = this.dataset.quantitySelector || '.quantity';

    this.shadow = this.attachShadow({mode: 'open'});
    this.shadow.appendChild(tpl.content.cloneNode(true));
  }

  get canvas() {
    return this.shadow.querySelector('canvas');
  }

  connect() {
    let quantitySum = 0;

    this.querySelectorAll(this.datasetSelector).forEach((dataSet, n) => {
      let graphColour  = dataSet.dataset.graphColour;
      let speciesElem  = dataSet.querySelector(this.speciesSelector);
      let quantityElem = dataSet.querySelector(this.quantitySelector);

      this.chartData.datasets[0].backgroundColor.push(`rgba(${graphColour},0.6)`);
      this.chartData.datasets[0].hoverBorderColor.push(`rgba(${graphColour},0.9)`);
      this.chartData.datasets[0].hoverBackgroundColor.push(`rgba(${graphColour},0.9)`);

      quantityElem.style.backgroundColor = `rgba(${graphColour},0.9)`;
      quantityElem.style.color      = '#fff';
      quantityElem.style.fontWeight = 'bold';
      quantityElem.style.textAlign  = 'center';
      this.chartData.labels[n]      = speciesElem.innerText;
      this.chartData.datasets[0].data[n] = parseInt(quantityElem.innerText);
      quantitySum += this.chartData.datasets[0].data[n];
    });

    this.shadow.querySelector('.quantity-sum').innerText = quantitySum;

    const size = `${this.getAttribute('size')}`;
    if (size !== '') {
      const c = this.canvas;
      c.setAttribute('width', size);
      c.setAttribute('height', size);
      c.style.maxHeight = `${size}px`;
      c.style.maxWidth = `${size}px`;
    }

    this.buildChart('doughnut', this.chartData, this.chartOptions);
  }
}
